import { render } from "./EmailSendingHistory.vue?vue&type=template&id=126f2016&scoped=true"
import script from "./EmailSendingHistory.vue?vue&type=script&lang=js"
export * from "./EmailSendingHistory.vue?vue&type=script&lang=js"

import "./EmailSendingHistory.vue?vue&type=style&index=0&id=126f2016&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-126f2016"

export default script